import { Box, BoxProps, Stack } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export const SimpleStatWrapper = ({
  children,
  ...props
}: PropsWithChildren<BoxProps>) => {
  return (
    <Box
      px={{ base: "4", md: "6" }}
      py={{ base: "5", md: "6" }}
      color="white"
      {...props}
    >
      <Stack spacing={{ base: "2", md: "4" }} justify="center">
        {children}
      </Stack>
    </Box>
  );
};
